import {PlatformAPIHttpClient} from "./platform-api-http-client";

export class UsersHttpClient extends PlatformAPIHttpClient {
    public getAuthenticatedUserInfo = () => this.instance.get('/users/me');
}